import React from 'react'
import { bool, number, string } from 'prop-types'

export const Reddit = ({
  ariaHidden,
  fill2,
  fill,
  focusable,
  height,
  title,
  width,
  isDark,
  ...rest
}) => {
  const h = height || '1rem'
  const w = width || '1rem'

  return (
    <svg
      width={w}
      height={h}
      viewBox='0 0 319 319'
      aria-hidden={ariaHidden}
      focusable={focusable}
      fill={fill}
      stroke='none'
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <circle
        fillRule='evenodd'
        fill={isDark ? '#fff' : fill}
        cx='159.500258'
        cy='159.500258'
        r='158.964339'
        strokeWidth='1'
      />
      <path
        d='M265.538952,159.500258 C265.538952,146.601223 255.107989,136.357664 242.396358,136.357664 C236.13778,136.357664 230.44495,138.8222 226.272564,142.807182 C210.339711,131.425056 188.523086,124.027913 164.241926,123.080286 L174.863829,73.3793998 L209.388548,80.7765437 C209.770428,89.5031933 216.976632,96.5219938 225.894221,96.5219938 C234.999214,96.5219938 242.396358,89.1248499 242.396358,80.016321 C242.396358,70.9113279 234.999214,63.5141841 225.894221,63.5141841 C219.444704,63.5141841 213.751873,67.3082258 211.096397,72.8101168 L172.590233,64.6527502 C171.451667,64.4618105 170.3131,64.6527502 169.552878,65.2220332 C168.605251,65.7913163 168.035968,66.7389428 167.848564,67.8775089 L156.08456,123.26769 C131.425056,124.027913 109.230089,131.425056 93.1062954,142.998121 C88.7638307,138.850505 82.9874704,136.539961 76.9825019,136.548604 C64.0834671,136.548604 53.839908,146.979567 53.839908,159.691198 C53.839908,169.174534 59.5292026,177.140961 67.4991655,180.747599 C67.1172862,183.021196 66.9298824,185.298328 66.9298824,187.7664 C66.9298824,223.426149 108.473402,252.452513 159.691198,252.452513 C210.908994,252.452513 252.452513,223.617089 252.452513,187.7664 C252.452513,185.489267 252.261574,183.021196 251.88323,180.747599 C259.849657,177.140961 265.538952,168.983595 265.538952,159.500258 L265.538952,159.500258 Z M106.574613,176.002395 C106.574613,166.897402 113.971757,159.500258 123.080286,159.500258 C132.185279,159.500258 139.582423,166.897402 139.582423,176.002395 C139.582423,185.107388 132.185279,192.508068 123.080286,192.508068 C113.971757,192.695472 106.574613,185.107388 106.574613,176.002395 L106.574613,176.002395 Z M198.957585,219.823047 C187.57546,231.205172 165.949776,231.965395 159.691198,231.965395 C153.24168,231.965395 131.615996,231.014233 120.421275,219.823047 C118.716961,218.115198 118.716961,215.459722 120.421275,213.751873 C122.129124,212.04756 124.784599,212.04756 126.492448,213.751873 C133.702189,220.961613 148.878356,223.426149 159.691198,223.426149 C170.50404,223.426149 185.867611,220.961613 192.886411,213.751873 C194.59426,212.04756 197.249736,212.04756 198.957585,213.751873 C200.474495,215.459722 200.474495,218.115198 198.957585,219.823047 Z M195.92023,192.695472 C186.815237,192.695472 179.418093,185.298328 179.418093,176.193335 C179.418093,167.088342 186.815237,159.691198 195.92023,159.691198 C205.028759,159.691198 212.425903,167.088342 212.425903,176.193335 C212.425903,185.107388 205.028759,192.695472 195.92023,192.695472 Z'
        fillRule='evenodd'
        fill={fill2}
      />
    </svg>
  )
}

Reddit.defaultProps = {
  ariaHidden: false,
  focusable: false,
  fill2: '#FFFFFF',
  fill: '#FF4500',
}

Reddit.propTypes = {
  ariaHidden: bool,
  fill2: string,
  fill: string,
  focusable: bool,
  height: number,
  title: string,
  width: number,
  isDark: bool,
}
